export default "__VITE_ASSET__C6Rz6EWQ__"